<template>

  <b-card class="mt-2" style="border: 1px solid #c9c9c9">
    
    <b-col md="12">

      <b-row class="d-flex align-items-center">
        <b-col md="5">
          <b-form-group label-for="v-norden">
            <validation-provider #default="{ errors }" name="norden">
              <span>Número de Orden AS400</span>
              <b-form-input 
                id="v-norden" 
                :state="errors.length > 0 ? false : null"
                v-model="norden" 
                type="text" 
              />
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-form-checkbox
          class="col offset-1"
          v-model="search400Name"
          switch
        >
          Busqueda por nombres
        </b-form-checkbox>
          
      </b-row>

      <b-row 
        v-if="search400Name"
        class="mb-1"
      >
        <SearchOpts
          v-model="tempLab400"
          :searchService="searchLab400ByName"
          class="col-10"
          placeholder="Buscar examen por nombre"
          :minChars="3"
          :omit="omitLab400"
        /> 

        <div>
          <b-button
            size="sm"
            variant="warning"
            @click="addLab400ToExamens"
            :disabled="!tempLab400"
          >+</b-button>
        </div>

        <div class="col-10 mt-1">
          <div 
            v-for="(examen, index) in examenesListByName" 
            :key="index"
            class="mx-1"
          >
            {{ examen.text  }}
          </div>  
        </div> 
        
      </b-row>

      <b-row
        v-if="!search400Name"
        class="mb-1"
      >
        <b-col>
          <span>Ingresar Examenes:</span>
          <b-form-textarea 
            v-model="exa4" 
            type="text" 
          />
        </b-col>
      </b-row>

      <b-row class="mb-1" v-if="showJustificacion">
        <b-col>
          <span>Justificacion:</span>
          <b-form-textarea 
            v-model="tempJustificacion" 
            type="text" 
          />
        </b-col>
      </b-row>

      <b-col md="12" class="d-flex justify-content-end my-2">
        <b-button 
          variant="info" 
          size="sm" 
          @click="addLabAS400()"
        >
          <span>Agregar</span>
        </b-button>
      </b-col>

    </b-col>

    <div v-if="laboratoriosAs400X && laboratoriosAs400X.length">
      <h5 class="text-center">Tabla de Exámenes de Laboratorio</h5>

      <b-table
        v-if="laboratoriosAs400X"
        :items="laboratoriosAs400X"
        :fields="fieldsLabAs400"
      >
        <template #cell(examenes)="data">
          <div>
            <span v-for="(examen, index) in data.item.examenes" :key="index">
              ({{ examen.codigo }}) {{ examen.descripcion }} <br>
            </span>
          </div>
        </template>

        <template #cell(acciones)="data">
          <div class="d-flex justify-content-end">
            <b-button 
              variant="primary" 
              size="sm" 
              style="cursor: pointer;"
              @click="editItemLaboratorio(data.item, data.index)"
            >
              <font-awesome-icon icon="user-pen" style="color: rgb(253, 253, 253);" />
            </b-button>
            <b-button 
              variant="danger" 
              size="sm"
              @click="removeLaboratorio(data.index)"
            >
              <font-awesome-icon 
                icon="circle-xmark" 
                style="color: rgb(255, 255, 255);" 
              />
            </b-button>
          </div>
        </template>
      </b-table>
    </div>

    

    <b-modal
      id="modal-editar-laboratorio" 
      size="lg"
      hide-footer
    >

      <b-card v-if="lab400ToEdit">

        <h4 class="text-center">Editar Laboratorio AA</h4>

        <b-row class="d-flex align-items-center my-2">
          <h6 class="col-3">Número de orden: </h6>
          <b-input
            v-model="lab400ToEdit.numeroOrden"
            class="col-4"
          />
        </b-row>


        <b-row class="mb-2">
          <SearchOpts
            v-model="tempLab400"
            :searchService="searchLab400ByName"
            class="col-10"
            placeholder="Buscar examen por nombre"
            :minChars="3"
            :omit="omitLab400Edit"
          />

          <div>
            <b-button
              size="sm"
              variant="warning"
              @click="addLab400ToExamensEdit"
              :disabled="!tempLab400"
            >+</b-button>
          </div>
        </b-row>
        

        <b-row 
          v-for="(item, index)  in lab400ToEdit.examenes" 
          :key="index"
          class="mb-1"
        >

          <b-col cols="8">
            {{ item.codigo}} - {{ item.descripcion }}
          </b-col>

          <b-col cols="2">
            <b-button 
              @click="deleteExamen(item)" 
              variant="danger" 
              size="sm"
            > 
              <i class="fas fa-trash"/>
            </b-button> 
          </b-col>

          <hr class="col-9 m-0"/>

        </b-row>


        <b-alert
          v-if="!lab400ToEdit.examenes.length"
          variant="danger" 
          show
          class="p-2 text-center"
        >
          No puede guardar el laboratorio sin exámenes
        </b-alert>

        <div class="row my-2" >
          <span class="col-3">Justificacion: </span>
          <b-form-textarea
            class="mx-1"
            v-model="lab400ToEdit.justificacion"
          />
        </div>

        <div class="d-flex justify-content-end mb-1">
          <b-button 
            variant="success"
            @click="onSaveEditLaboratorio(lab400ToEdit)"
            :disabled="!lab400ToEdit.examenes.length"
          >
            Guardar Cambios
          </b-button>
        </div>

      </b-card>

      
      
    </b-modal>

  </b-card>
              
  
</template>

<script>
import { mapState } from "vuex";
import rutas from '@/assets/utils/rutas.json';
import 'flatpickr/dist/flatpickr.css';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { ValidationProvider } from 'vee-validate';
import axios from 'axios';
import { getEstablecimientoLS } from "@/shared/helpers";
import { SearchOpts } from "@/shared/components";
import { estudioLabService, labAs400Service } from "@/views/laboratorio/services";

export default {

  name: 'AtencionLabAs400',
  
  props: {

    idPaciente: { // valido para buscar examenes ant 2 meses
      type: String,
      default: ''
    }
  },

  components: {
    SearchOpts,
    ValidationProvider,
  },


  data() {
    return {
      
      tokenAtencion:null,

      lab400ToEdit: null,

      search400Name:false,
      tempLab400:null,
      examenesListByName: [],

      exa4 : null,
      hasExecuted: false,
      doctor: null,
      especialidad: null,
      codigoslabs: null,
      loading: false,
      currentLaboratorio: null,
      examlabsa400: null,
      codsLabs: [],
      idsLabs: [],
      examenesAS400: null,
      selectedOption: null,
      collapseItemID: '',
      titularsel: '',
      isLoading: false,
      modalidad: '1',
      openOnHover: this.$parent.hover,
      options: {},
      titulares: [],

      laboratorioas4: [],

      norden: '',
      currentItemLaboratorio: {
        norden: '',
      },
      editingIndex: null,


      showJustificacion: false,
      tempJustificacion: '',

      fieldsLabAs400: [
        { key: 'numeroOrden', label: 'Número de Orden AS400', thClass: 'text-center' },
        { key: 'examenes',    label: 'Codigo / Examenes',     thClass: 'text-center' },
        { key: 'acciones',    label: 'acciones',              thClass: 'text-center', tdClass: 'text-right', sortable: true, },
      ],
  
      idcita: 0,

      laboratoriosAs400X: null,
      currentExamenes: null,

      indexLabToEdit: null,
    };
  },

  async created() {
    await this.clearState();
    this.tokenAtencion = this.$route.params.token;
    this.loadDataRegister()
  },

   
  computed: {

    ...mapState({
      dataAtencionMedica  : state => state.atencionCita.dataCita,
      stLaboratorioList   : state => state.atencionCita.laboratorios.laboratorioList,
      stLaboratoriosFinal : state => state.atencionMedica.editarAtencion.laboratorios.final,
    }),

    omitLab400(){

      const omits = this.examenesListByName.map(
        l => ({ id: l.id, token: null })
      );

      return omits; 
    },


    omitLab400Edit(){

      const omits = this.lab400ToEdit.examenes.map(
        l => ({ id: l.id, token: null })
      );

      return omits;
    },

  },


  methods: {

    clearState(){
      this.$store.commit("resetLabAs400");
    },

    async searchLab400ByName(search) {
      const establecimiento = getEstablecimientoLS();
      const responseSearch400 = await labAs400Service.searchLab(search, establecimiento.id);

      // Filtrar duplicados por código
      const seenCodes = new Set();
      const uniqueLabs = responseSearch400.filter(result => {
        if (seenCodes.has(result.codigo)) return false;
        
        seenCodes.add(result.codigo);
        return true;
      });

      // Mapear a la estructura deseada
      const labMapped = uniqueLabs.map(result => {
        return {
          ...result,
          value: result.id,
          text: `(${result.codigo}) ${result.descripcion}`
        };
      });

      return labMapped;
    },


    addLab400ToExamens(){
      this.examenesListByName.push(this.tempLab400);
      this.tempLab400 = null;
    },


    async addLab400ToExamensEdit(){
      this.lab400ToEdit.examenes = [...this.lab400ToEdit.examenes, this.tempLab400];
      this.tempLab400 = null;
    },


    async onSaveEditLaboratorio(item){
      
      const labs400Modificados = this.laboratoriosAs400X.map((laboratorio, index) => {
        return (index === item.index)
          ? { ...item }
          : laboratorio
      });

      this.laboratoriosAs400X = labs400Modificados

      await this.$swal.fire({
        title: 'Laboratorio editado',
        icon: 'success',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#3085d6',
      });

      this.$bvModal.hide('modal-editar-laboratorio');

    },


    async deleteExamen(item) {

      const result = await this.$swal.fire({
        title: 'Eliminar Item Examen',
        text: "Estas seguro de eliminar este examen?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      this.lab400ToEdit.examenes = this.lab400ToEdit.examenes.filter(
        examen => examen.id !== item.id
      )
        
    },


    async obtenerLabsEstablecimiento (){

      let idEstablecimiento = null
      if (this.dataAtencionMedica) {
        idEstablecimiento = this.dataAtencionMedica.establecimiento.id
      }

      const query = `
        query MyQuery {
          getAllLabos(establecimiento : ${idEstablecimiento}) {
            status
            laboratorio {
              id
              codigo
              descripcion
            }
            message
            total
          }
        }
      `;

      try {
          
        const response = await axios.post(rutas.axios + 'api', { query });

        if (response.data.data.getAllLabos.status === 'Success') {
          this.codsLabs = response.data.data.getAllLabos.laboratorio.map(item => ({
            id         : item.id,
            codigo     : item.codigo,
            descripcion: item.descripcion
          }));
        }

      }catch (error) {
        console.log("fetch all labs error", error)
      }
    },


    async loadDataRegister(){

      if(!this.tokenAtencion) {
        this.laboratoriosAs400X = [];
        return;
      }

      const responseLaboratorios = await estudioLabService.getByAtencion(this.tokenAtencion);

      
      if(!responseLaboratorios) {
        this.laboratoriosAs400X = [];
        return;
      }

      const laboratoriosParsed = JSON.parse(JSON.stringify(responseLaboratorios));

      const laboratoriosInicial = laboratoriosParsed.labAs400;
      const laboratoriosFinal   = laboratoriosParsed.labAs400;
      const estudioLaboratorio  = laboratoriosParsed.estudioLab;

      this.$store.commit("setLaboratoriosAs400EstudioLab", estudioLaboratorio);
      this.$store.commit("setLaboratoriosAs400Inicial", laboratoriosInicial);
      this.$store.commit("setLaboratoriosAs400Final", laboratoriosFinal);

      this.laboratoriosAs400X = responseLaboratorios.labAs400;
    },


    // Métodos para editar laboratorio
    editItemLaboratorio(item, index) {
      this.lab400ToEdit = { ...item, index };
      this.$bvModal.show("modal-editar-laboratorio")
    },



    // Métodos para editar auxiliar
    async removeLaboratorio(indexLab) {

      const result = await this.$swal({
        title: '¿Estás seguro de eliminar este elemento?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
        cancelButtonText: 'No, cancelar'

      });

      if (!result.isConfirmed) return;
      
      this.laboratoriosAs400X.splice(indexLab, 1);

      this.$swal(
        'Eliminado!',
        'Eliminado correctamente.',
        'success'
      );
    },

    

    async addLabAS400(){

      if(!this.norden){
        this.$swal({
          title: 'Error',
          text: 'Por favor, llene todos los campos antes de agregar.',
          icon: 'error',
        });

        return;        
      }

      // validar el numero de orden no sea repetido en la misma atencion

      const ordenRepetido = this.laboratoriosAs400X?.some( 
        lab => lab.numeroOrden === this.norden
      );

      if (ordenRepetido) {
        this.$swal({
          title: 'Error',
          text: `El número de orden ${this.norden} ya existe en la lista.`,
          icon: 'error',
        });
        return;
      }

      const examenesEncontrados = (this.search400Name)
        ? this.examenesListByName
        : await this.extraerCodigos();

      if(!examenesEncontrados.length){
        this.$swal({
          title: 'Error',
          text: 'No se encontraron examenes con los codigos ingresados.',
          icon: 'error',
        });
        return;
      }
      this.currentExamenes = examenesEncontrados;

      // revisar examenes repetidos en la misma atencion

      const hayRepetidosEnAtencion = await this.validateExamenRepetidoEnAtencion();

      if(hayRepetidosEnAtencion){
        this.showJustificacion = true;
        return;
      }

      this.showJustificacion = false;

      // revisar examenes repetidos en los dos ultimos meses
      // this.validateExamenRepetido2Meses();

      
      // mappear info para la tabla
      const newLab = {
        numeroOrden  : this.norden,
        examenes     : examenesEncontrados,
        justificacion: this.tempJustificacion || null
      };

      this.laboratoriosAs400X.push(newLab);

      // enviar datos
      // los datos se envian desde editarCitaMedica

      // limpiar
      this.norden = null;
      this.tempJustificacion = '';
      this.examenesListByName = [];
      this.exa4 = '';
    },


    async extraerCodigos(){

      const establecimiento = getEstablecimientoLS();

      try{
        const regex = /\b\d{6}\b/g;
        const codes = this.exa4.match(regex) || [];
        
        const searchPromises = codes.map( 
          async(c) => await labAs400Service.getByCodeAndEstablecimiento(c, establecimiento.id)
        );
        
        const resultsSearch = await Promise.all(searchPromises);
        const validResults = resultsSearch.filter( r => r !== null);
        return validResults;

      }catch(error){
        console.log('error al extraer codigos', error);
        return [];
      }

    },


    async validateExamenRepetidoEnAtencion(){

      if(this.tempJustificacion) return false;

      const idLabsTable = this.laboratoriosAs400X.flatMap(
        lab => lab.examenes.map(examen => examen.id)
      );

      const repetidosEnAtencion = this.currentExamenes.filter(
        examen => idLabsTable.includes(examen.id)
      );

      if(repetidosEnAtencion.length){
        const textoRepetidos = repetidosEnAtencion
          .map(r => `(${r.codigo}) - ${r.descripcion}`)
          .join('\n'); 

        this.$swal({
          title: 'Error',
          text: `Debera agregar una justificacion ya que los examenes siguientes ya se encuentran en la atención:\n${textoRepetidos}`,
          icon: 'error',
        });

        return true;
      }

      return false;
    },
    

    // todo
    async validateExamenRepetido2Meses(){
      const historialResponse = await estudioLabService.getHistorialByPaciente(this.idPaciente);
      console.log('historialResponse', historialResponse);

      return;
      const labsFromLastTwoMonths = historialResponse
        .filter(est => {
          const today = new Date();
          const fechaLab = new Date(est.fechaCreacion);
          const twoMonthsLater = new Date(fechaLab);
          twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);
          return today <= twoMonthsLater;
        })
        .map(est => ({
          fecha: est.fechaCreacion,
          examenes: est.idslaboratorios.split(', '),
        }));

      const currentExams = this.laboratorioas4.flatMap( lab => lab.detalle );

      const labsRepetidos = labsFromLastTwoMonths.flatMap(
        lab => lab.examenes
          .filter(examenId => currentExams.some(det => det.id === examenId))// Filtrar los exámenes que coinciden
          .map(examenId => {
            const dataExamen = currentExams.find(det => det.id === examenId);
            return { fecha:(lab.fecha).split('T')[0], examen: dataExamen };
          })
      );


      if(labsRepetidos.length > 0) {

        const laboratoriosText = labsRepetidos.map(
          lab => `<div class="text-left">${lab.fecha}: (${lab.examen.codigo}) ${lab.examen.descripcion}</div>`
        ).join('<br>');

        const text = `Laboratorio(s) ya enviado(s) en los últimos dos meses: <br><br>${laboratoriosText}`

        const result = await this.$swal({
          title              : "¡Laboratorios ya existentes!",
          html               : text,
          icon               : "warning",
          confirmButtonColor : "#089599",
          confirmButtonText  : "Sí",
          cancelButtonText   : "No",
          showCancelButton   : true,

        });

        if (!result.isConfirmed) return;
      }
    },

     
  },


  watch : {

    laboratoriosAs400X:{
      deep: true,
      handler(newValue){
        this.$store.commit('setLaboratoriosAs400Final', newValue);
      }
    },

        
    dataAtencionMedica: {
      deep: true,
      handler(newValue) {
        if (newValue ) this.obtenerLabsEstablecimiento()
      }

    }
  }
}
</script>
